module.exports = __webpack_public_path__ + "img/kcoin-icon.d775763.png";